import { BrowserModule, provideClientHydration, withEventReplay } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { RouterModule, Routes } from "@angular/router";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { HttpTimeoutInterceptor } from "./http-timeout.interceptor";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { SharedModule } from "./shared/shared.module";
import { PrintmycardComponent } from "./printmycard/printmycard.component";

const appRoutes: Routes = [
  { path: "", component: HomeComponent, pathMatch: "full" },
  { path: "Home", component: HomeComponent },
  { path: "printmycard", component: PrintmycardComponent },
  {
    path: "Pharmacy",
    loadChildren: () =>
      import("./pharmacy/pharmacy.module").then((m) => m.PharmacyModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./enrollment/enrollment.module").then((m) => m.EnrollmentModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./content-pages/content-pages.module").then(
        (m) => m.ContentPagesModule
      ),
  },
  { path: "**", component: HomeComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    PrintmycardComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes, {
      // enableTracing: true // <-- debugging purposes only
    }),
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  providers: [
    provideClientHydration(withEventReplay()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTimeoutInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
